// @flow
import type { CurrentUser } from 'api/currentUser';
import { isAfter, parseISO } from 'date-fns';
import {
  dismissNotification,
  notificationIsDismissed,
  NOTIFICATIONS
} from 'utils/localNotifications';
import { configValue } from 'utils/config';
import { getItem } from 'utils/localStorage';
import { isDefined } from 'utils/functional';
import { isNonAdmin } from 'utils/currentUser';

const NEW_USER_DATE = new Date('2020-11-16T17:00:00Z');

export const dismissResumeDBLoggedOut = () =>
  dismissNotification(NOTIFICATIONS.UPLOAD_RESUME);

export const hasResumeDb = (user: CurrentUser) =>
  configValue('idealist', 'resumeDb', 'enabled') &&
  getItem('enableResumeDb') !== false &&
  (user.isUS || user.isRecruitable) &&
  USER_LOCALE === 'en';

export const hasProfile = (user: CurrentUser) =>
  user.applicantProfile &&
  (user.applicantProfile.workHistoryJobs.length > 0 ||
    (user.applicantProfile.skills && user.applicantProfile.skills.length > 0));

export const promoteResumeDatabase = ({
  currentUser,
  includeDate,
  allowLoggedOut
}: {
  currentUser: CurrentUser,
  includeDate?: boolean,
  allowLoggedOut?: boolean
}) =>
  hasResumeDb(currentUser) &&
  !notificationIsDismissed(NOTIFICATIONS.UPLOAD_RESUME) &&
  ((allowLoggedOut && currentUser && !currentUser.id) ||
    (isNonAdmin(currentUser) &&
      (!isDefined(currentUser.isRecruitable) ||
        (currentUser.isRecruitable && !currentUser.resumeId)))) &&
  (!includeDate || isAfter(parseISO(currentUser.created), NEW_USER_DATE));
